export const isTicketCancellable = (date) => {
    const createdDate = new Date(date);
    const now = new Date();

    const difference = now.getTime() - createdDate.getTime();
    const minutesDifference = difference / (1000 * 60);
    return minutesDifference < 5
}